<p
    [id]="id() + '-text'"
    [class.long-text]="true"
    [class.overflow]="maxHeight() !== undefined"
    [style.max-height]="maxHeight() ? maxHeight() : 'unset'">
    {{ text() || '-' | translate }}
</p>
